"use client";

import { usePathname } from "next/navigation";

import { cn } from "@louez/utils";

import { StoreFooter } from "@/components/storefront/store-footer";
import { StoreHeader } from "@/components/storefront/store-header";

type StorefrontChromeProps = {
  address?: string | null;
  children: React.ReactNode;
  email?: string | null;
  logoUrl?: string | null;
  phone?: string | null;
  storeName: string;
  storeSlug: string;
};

export const StorefrontChrome = ({
  address,
  children,
  email,
  logoUrl,
  phone,
  storeName,
  storeSlug,
}: StorefrontChromeProps) => {
  const pathname = usePathname();
  const servicePrefix = `/${storeSlug}/services`;
  const storefrontRoot = `/${storeSlug}`;
  const usesPortHeader =
    storeSlug === "nautic-alvarez" &&
    (pathname === "/" ||
      pathname === storefrontRoot ||
      pathname === `${storefrontRoot}/` ||
      pathname === "/services" ||
      pathname.startsWith("/services/") ||
      pathname === servicePrefix ||
      pathname.startsWith(`${servicePrefix}/`));

  return (
    <div className="flex min-h-screen flex-col bg-background">
      {!usesPortHeader && (
        <StoreHeader storeName={storeName} storeSlug={storeSlug} logoUrl={logoUrl} />
      )}
      <main className={cn("flex-1", !usesPortHeader && "pt-20 md:pt-24")}>{children}</main>
      <StoreFooter
        storeName={storeName}
        storeSlug={storeSlug}
        email={email}
        phone={phone}
        address={address}
      />
    </div>
  );
};
